import { render } from "./ReplaceImageLabel.vue?vue&type=template&id=12365c94&scoped=true"
import script from "./ReplaceImageLabel.vue?vue&type=script&lang=js"
export * from "./ReplaceImageLabel.vue?vue&type=script&lang=js"

import "./ReplaceImageLabel.vue?vue&type=style&index=0&id=12365c94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12365c94"]])

export default __exports__